<template>
  <div class="home">
    <div class="all-div">
      <loading :color="load_color" :active="true"></loading>
      <div class="load-text">กำลังโหลดดดด...</div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  name: "home",
  data() {
    return {
      load_color: "#FFFFFF",
    };
  },
  components: {
    Loading,
  },
  mounted() {
    const params = this.$route.params.pathMatch;
    console.log(params);
    window.location.href = "https://www.myfriendshipp.site/" + params;
  },
};
</script>
<style lang="scss">
.home {
  height: 100vh;
  width: 100vw;
  background: #e75035;
  display: flex;
  justify-content: space-between;

  .all-div {
    margin: auto;
    padding: auto;
  }
}

.load-text {
  font-size: 4.2vh;
  line-height: 5.5vh;
  text-align: center;
  color: #e8d9d4;
}
</style>
